import { RefObject, useEffect, useState } from 'react'

export const useElementHorizontalScroll = (
    elementRef: RefObject<HTMLDivElement>
) => {
    const [scrollPosition, setScrollPosition] = useState(0)
    const [hasNextButton, setHasNextButton] = useState(false)
    const [hasPrevButton, setHasPrevButton] = useState(false)

    const handleScroll = (scrollAmount: number) => {
        if (!elementRef?.current) return
        const { width } = elementRef.current.getBoundingClientRect()
        const maxScrollPosition = elementRef.current.scrollWidth - width

        let newScrollPosition = scrollPosition + scrollAmount
        if (newScrollPosition < 0) {
            newScrollPosition = 0
        } else if (newScrollPosition > maxScrollPosition) {
            newScrollPosition = maxScrollPosition
        }
        setScrollPosition(newScrollPosition)
        elementRef.current.scrollLeft = newScrollPosition
    }

    useEffect(() => {
        if (!elementRef?.current) return
        const { width } = elementRef.current.getBoundingClientRect()
        const { scrollWidth } = elementRef.current
        const maxScrollPosition = scrollWidth - width
        const hasButtons = scrollWidth > width
        setHasNextButton(hasButtons && scrollPosition < maxScrollPosition)
        setHasPrevButton(hasButtons && scrollPosition > 0)
    }, [scrollPosition])

    return { handleScroll, hasNextButton, hasPrevButton }
}
